module.exports = __webpack_public_path__ + "img/mobieli_white_epump_logo.f708e2e6.svg";